<ngx-ui-loader [loaderId]="'individualdashboard'"></ngx-ui-loader>
<div id="denyDashboardAccess" class="background">
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-3">
                    <mat-card class="shadows">
                        <mat-card-content>
                                    Age of the Transformer :
                                    <b>{{ageTransformer}}</b> Year 
                                    <br>
                                    <ng-select [items]="transformerList" bindLabel="transformerDetail"
                                                placeholder="Transformer" [(ngModel)]="selectedTransformer"
                                                (change)="transformerSelection(selectedTransformer)" [clearable]="false">
                                    </ng-select>
                                    <ng-select [items]="parameterList" bindLabel="name" placeholder="Parameters"
                                        [(ngModel)]="selectedParameter" (change)="parameterSelection(selectedParameter)"
                                        [clearable]="false">
                                    </ng-select>

                         </mat-card-content>
                     </mat-card>
                  </div>   <br>
                <div class="col-md-9">
                    <mat-card class="shadows">
                        <mat-card-content>
                            <div class="row" style="padding-left: 5px;">
                                <div class="col-md-2" *ngIf="selectedParameter" style="margin:0% 0% 0% 4%">
                                    <div class="row" *ngIf="data.length > 0" style="text-align: center;">
                                        <div *ngIf="selectedParameter && (selectedParameter.name == 'Oil Temperature' || selectedParameter.name == 'Oil Level' || selectedParameter.name == 'Frequency' || selectedParameter.name == 'Ambient Temperature' || selectedParameter.name == 'Load Percentage' || selectedParameter.name == 'I Unbalance' || selectedParameter.name == 'Winding Temperature' || selectedParameter.name == 'V Unbalance' || selectedParameter.name == 'Winding_Temp_By_Cal') ">
                                            <b >Latest Data: {{ValuesForOilTemp | number : '1.2'}} </b>
                                            <ejs-circulargauge id="circular-container" height='150px' width='150px'>
                                                <e-axes>
                                                    <e-axis [lineStyle]="lineStyle">
                                                        <e-ranges>
                                                            <e-range start=0 end=100 radius="108%"></e-range>
                                                        </e-ranges>
                                                        <e-pointers>
                                                            <e-pointer [value]="ValuesForOilTemp" [color]='RangeColor' type="Marker" markerShape="InvertedTriangle" radius="100%" [markerHeight]="markerSize" [markerWidth]="markerSize"></e-pointer>
                                                            <e-pointer [value]="ValuesForOilTemp"  [color]='RangeColor' type="RangeBar" radius="50%" pointerWidth=5></e-pointer>
                                                            <e-pointer [value]="ValuesForOilTemp"  [color]='RangeColor' radius="60%" pointerWidth=10 [cap]="pointerCap" ></e-pointer>
                                                        </e-pointers>
                                                    </e-axis>
                                                </e-axes>
                                            </ejs-circulargauge>
                                            <p><b>{{latestDataDate}}</b></p>
                                        </div>
                                        <div *ngIf="selectedParameter.name == 'Humidity'">
                                            <b style="margin: 0% 0% 0% 15%;">Latest Data: {{ValuesForOilTemp}} </b>
                                            <ejs-circulargauge id="circular-container" height='150px' width='150px'>
                                                <e-axes>
                                                    <e-axis>
                                                        <e-ranges>
                                                            <e-range start=0 end=100 radius="108%"></e-range>
                                                        </e-ranges>
                                                        <e-pointers>
                                                            <e-pointer [value]="ValuesForOilTemp" type="Marker" markerShape="Triangle" radius="100%" color="white" [markerHeight]="15" [markerWidth]="15" [border]="pointerBorder"></e-pointer>
                                                        </e-pointers>
                                                    </e-axis>
                                                </e-axes>
                                            </ejs-circulargauge>
                                        </div>
                                        <div *ngIf="data.length > 0" >
                                            <div *ngIf="selectedParameter.name ==  'Ampere' || selectedParameter.name ==  'V Variance'  || selectedParameter.name ==  'KVAr' || selectedParameter.name ==  'Lug Temperature'">
                                                <b><p >Latest Data </p>
                                                    <div class="row" style="width: 400px;margin: 1% 0% 0% 0%;">
                                                <div class="col-md-3">
                                                <div style="height: 100px;width: 100px;background-color: #fa2828;  text-align: center;">
                                                    R <br>Phase<br> <h5>{{valueForPhaseA}}</h5>
                                                </div>&nbsp;&nbsp;&nbsp;
                                                 </div><div class="col-md-1"></div>
                                                 <div class="col-md-3">
                                                <div style="height: 100px;width: 100px;background-color: #F7F743;  text-align: center;">
                                                    Y <br>Phase<br> <h5>{{valueForPhaseB}}</h5>
                                                </div>
                                                </div><div class="col-md-1"></div>
                                                <div class="col-md-3">
                                                    <div style="height: 100px;width: 100px;background-color: #4365F7;  text-align: center;">
                                                        B <br>Phase<br> <h5>{{valueForPhaseC}}</h5>
                                                    </div>
                                                    </div>
                                                    
                                            </div>
                                            <p style="margin: -3% 0% 0% 0%;">{{latestDataDate}}</p>
                                        </b>
                                        </div>
                                        <div *ngIf="selectedParameter.name ==  'Voltage' ">
                                            <b><p >Latest Data </p>
                                                <div class="row" style="width: 400px;margin: 1% 0% 0% 0%;">
                                            <div class="col-md-3">
                                            <div style="height: 100px;width: 100px;background-color: #fa2828;  text-align: center;">
                                                R <br>Phase<br> <h5>{{valueForPhaseA}}</h5>
                                            </div>
                                             </div>
                                             <div class="col-md-3" style="margin-left:10px;">
                                            <div style="height: 100px;width: 100px;background-color: #F7F743;  text-align: center;">
                                                Y <br>Phase<br> <h5>{{valueForPhaseB}}</h5>
                                            </div>
                                            </div>
                                            <div class="col-md-3" style="margin-left:10px;">
                                                <div style="height: 100px;width: 100px;background-color: #4365F7;  text-align: center;">
                                                    B <br>Phase<br> <h5>{{valueForPhaseC}}</h5>
                                                </div>
                                                </div>
                                                <div class="col-md-2" style="margin-left:10px;">
                                                    <div style="height: 100px;width: 100px;background-color: #37d50b;  text-align: center;">
                                                        Average <br>Voltage<br> <h5>{{AverageVoltageValue}}</h5>
                                                    </div>
                                                    </div>
                                        </div>
                                        <br>
                                        <p style="margin: -3% 0% 0% 0%;">{{latestDataDate}}</p>
                                    </b>
                                    </div>
                                    <div *ngIf="selectedParameter.name ==  'PF' ">
                                        <b><p >Latest Data </p>
                                            <div class="row" style="width: 400px;margin: 1% 0% 0% 0%;">
                                        <div class="col-md-3">
                                        <div style="height: 100px;width: 100px;background-color: #fa2828;  text-align: center;">
                                            R <br>Phase<br> <h5>{{valueForPhaseA}}</h5>
                                        </div>
                                         </div>
                                         <div class="col-md-3" style="margin-left:10px;">
                                        <div style="height: 100px;width: 100px;background-color: #F7F743;  text-align: center;">
                                            Y <br>Phase<br> <h5>{{valueForPhaseB}}</h5>
                                        </div>
                                        </div>
                                        <div class="col-md-3" style="margin-left:10px;">
                                            <div style="height: 100px;width: 100px;background-color: #4365F7;  text-align: center;">
                                                B <br>Phase<br> <h5>{{valueForPhaseC}}</h5>
                                            </div>
                                            </div>
                                            <div class="col-md-2" style="margin-left:10px;">
                                                <div style="height: 100px;width: 100px;background-color: #37d50b;  text-align: center;">
                                                    Average <br>PF<br> <h5>{{avgPowerFactorValue}}</h5>
                                                </div>
                                                </div>
                                    </div>
                                    <br>
                                    <p style="margin: -3% 0% 0% 0%;">{{latestDataDate}}</p>
                                </b>
                                </div>
                                <div *ngIf="selectedParameter.name ==  'KW' ">
                                    <b><p >Latest Data </p>
                                        <div class="row" style="width: 400px;margin: 1% 0% 0% 0%;">
                                    <div class="col-md-3">
                                    <div style="height: 100px;width: 100px;background-color: #fa2828;  text-align: center;">
                                        R <br>Phase<br> <h5>{{valueForPhaseA}}</h5>
                                    </div>
                                     </div>
                                     <div class="col-md-3" style="margin-left:10px;">
                                    <div style="height: 100px;width: 100px;background-color: #F7F743;  text-align: center;">
                                        Y <br>Phase<br> <h5>{{valueForPhaseB}}</h5>
                                    </div>
                                    </div>
                                    <div class="col-md-3" style="margin-left:10px;">
                                        <div style="height: 100px;width: 100px;background-color: #4365F7;  text-align: center;">
                                            B <br>Phase<br> <h5>{{valueForPhaseC}}</h5>
                                        </div>
                                        </div>
                                        <div class="col-md-2" style="margin-left:10px;">
                                            <div style="height: 100px;width: 100px;background-color: #37d50b;  text-align: center;">
                                                3 Phase <br>Active Power<br> <h5>{{phaseActivePower}}</h5>
                                            </div>
                                            </div>
                                </div>
                                <br>
                                <p style="margin: -3% 0% 0% 0%;">{{latestDataDate}}</p>
                            </b>
                            </div>
                                    <div *ngIf="selectedParameter.name ==  'KVA' ">
                                        <b><p >Latest Data </p>
                                            <div class="row" style="width: 400px;margin: 1% 0% 0% 0%;">
                                        <div class="col-md-3">
                                        <div style="height: 100px;width: 100px;background-color: #fa2828;  text-align: center;">
                                            R <br>Phase<br> <h5>{{valueForPhaseA}}</h5>
                                        </div>
                                         </div>
                                         <div class="col-md-3" style="margin-left:10px;">
                                        <div style="height: 100px;width: 100px;background-color: #F7F743;  text-align: center;">
                                            Y <br>Phase<br> <h5>{{valueForPhaseB}}</h5>
                                        </div>
                                        </div>
                                        <div class="col-md-3" style="margin-left:10px;">
                                            <div style="height: 100px;width: 100px;background-color: #4365F7;  text-align: center;">
                                                B <br>Phase<br> <h5>{{valueForPhaseC}}</h5>
                                            </div>
                                            </div>
                                            <div class="col-md-2" style="margin-left:10px;">
                                                <div style="height: 100px;width: 100px;background-color: #37d50b;  text-align: center;">
                                                    3 Phase <br>Apparent Power<br> <h5>{{PhaseApparentPowerValue}}</h5>
                                                </div>
                                                </div>
                                    </div>
                                    <br>
                                    <p style="margin: -3% 0% 0% 0%;">{{latestDataDate}}</p>
                                </b>
                                </div>
                                    </div>
                                    </div>
                                    <div *ngIf="data && data.length == 0">
                                        <p class="text-danger">*Note: </p>
                                        <p class="alert alert-warning">No data to show results!</p>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <span *ngIf="showtableData">
                                            <table class="table" style="margin: 10% 0% 0% 0%;">
                                                <tbody>
                                                    <tr>
                                                        <td><b>Min</b></td>
                                                        <td>{{tableData?.min | number:'1.2-3'}}</td>


                                                        <td><b>Max</b></td>
                                                        <td>{{tableData?.max | number:'1.2-3'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><b>Average</b></td>
                                                        <td>{{tableData?.avg | number:'1.2-3'}}</td>

                                                        <td><b>Range</b></td>
                                                        <td>{{tableData?.range | number:'1.2-3'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                    </span>
                                    <div *ngIf="data && data.length == 0">
                                        <p class="text-danger">*Note: </p>
                                        <p class="alert alert-warning">No data to show results!</p>
                                    </div>
                                </div>
                                <div class="col-md-1"></div>
                                <div class="col-md-2" style="margin-left:10px;">
                                    <ng-select [items]="durationList" bindLabel="name" placeholder="Duration"
                                        [(ngModel)]="selectedDuration" (change)="durationSelection(selectedDuration)"
                                        [clearable]="false">
                                    </ng-select>
                                    
                                </div>

                                <div *ngIf="showDateRange" class="col-md-2" style="padding-top: 20px">
                                    <input [owlDateTime]="dt1" [selectMode]="'range'" [owlDateTimeTrigger]="dt1"
                                        placeholder="Select Date Range" (dateTimeChange)="changeDateRange($event)">
                                    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                                </div>
                                <div class="col-md-3">
                                    <div *ngIf="networkFlag" class="row">
                                        <div class="col-md-8">
                                            <div style="color: black;font-weight: bolder;margin-top: 5%;">Netwok Status: </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div style="margin-top: 5%;float: left;">
                                                <div class="signal-container">
                                                <div [matTooltip]="NetworkValue" matTooltipPosition="above"  matTooltipClass="auto-adjust-tooltip" *ngFor="let bar of bars; let i = index" [ngClass]="{'active': i < signalStrength}" class="signal-bar"></div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div> 
                                   
                                </div>
                               
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div><br>
            <div class="row">
                <div  class="col-md-12">
                    <mat-card class="shadows">
                        <mat-card-content>
                            <div *ngIf="selectedParameter">

                            <p style="padding: 5px;"><b>{{selectedParameter?.name}}</b></p> <span> <div class="btn-group meter-buttons" *ngIf="hasMeter2Data" role="group">
                                <button type="button" class="btn meter-btn" [ngClass]="{'btn-primary': selectedMeter === 1, 'btn-outline-primary': selectedMeter !== 1}" 
                                        (click)="selectMeter(1)">{{value1}}</button>
                                <button type="button" class="btn meter-btn" [ngClass]="{'btn-primary': selectedMeter === 2, 'btn-outline-primary': selectedMeter !== 2}" 
                                        (click)="selectMeter(2)">{{value2}}</button>
                            </div></span>
                            <hr>
                            <ngx-ui-loader [loaderId]="'individualdashboardgraph'"></ngx-ui-loader>
                            <span style="padding: 5px;" *ngIf="parameterValuedisplay && parameterValuedisplay.name1"><b>{{parameterValuedisplay?.name1}} :- </b></span>
                            <span *ngIf="parameterValuedisplay && parameterValuedisplay.value1"><b>{{parameterValuedisplay?.value1}}</b></span>
                            <span *ngIf="parameterValuedisplay && parameterValuedisplay.name2"><b>{{parameterValuedisplay?.name2}} :- </b></span>
                            <span *ngIf="parameterValuedisplay && parameterValuedisplay.value2"><b>{{parameterValuedisplay?.value2}}</b></span>
                            <div class="row" *ngIf="data.length > 0">

                                <div class=" col-md-12" style="height: 70vh;">
                                    <div *ngIf="selectedParameter.name == 'gauge parameter'; else othergraph">
                                        <plotly-plot [data]="data" [layout]="graph.layout" [config]="graph.config"
                                        [useResizeHandler]="true" [style]="{position: 'relative', width: '100%', height: '100%'}">
                                    </plotly-plot>
                                    </div>
                                    <ng-template #othergraph>

                                    <plotly-plot [data]="data" [layout]="graph.layout" [config]="graph.config"
                                        [useResizeHandler]="true" [style]="{position: 'relative', width: '100%', height: '100%'}">
                                    </plotly-plot>

                                </ng-template>
                                </div>

                            </div>
                            <div *ngIf="data && data.length == 0">
                                <p class="text-danger">*Note: </p>
                                <p class="alert alert-warning">No data to show results!</p>
                            </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>
</div>